import React, { useState } from "react";
import {
  Button,
  Container,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Dialog } from "@mui/material";
import { CreateLockerColorThunk } from "../Redux/SettingsModule/SettingsThunks";
import { useDispatch } from "react-redux";

const LockerColorsDialogSmall = ({}) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [place, setPlace] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSend = () => {
    dispatch(CreateLockerColorThunk(place));
    setOpen(false);
  };

  return (
    <Container sx={{ width: "500px" }}>
      <Button
        onClick={() => {
          handleOpen();
        }}
      >
        Dodaj nowy kolor Skrytki
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle variant="h5">Nowy Kolor Skrytki</DialogTitle>
        <DialogContent>
          <DialogContentText>Wprowadz dane</DialogContentText>

          <TextField
            margin="dense"
            id="LockerColorName"
            label="Nazwa Koloru"
            fullWidth
            variant="standard"
            onChange={(val) => {
              setPlace(val.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Anuluj</Button>
          <Button onClick={() => handleSend()}>Wyślij</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default LockerColorsDialogSmall;
